/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';
import cx from 'classnames';

import 'react-loading-skeleton/dist/skeleton.css';
import classes from './Connection.module.css';

export function ConnectionCardSkeleton({ cxname = '', css = {} }) {
  return (
    <div className={cx([classes.main_card], cxname)} style={css}>
      <Skeleton containerClassName={classes.mod_title} style={{ height: '100%', width: '100%' }} />
      <div className={classes.mod_content}>
        <Skeleton containerClassName={classes.mod_img} style={{ height: '100%', width: '100%' }} />
        <div className={classes.mod_info}>
          <div className={classes.mod_platform_name}>
            <Skeleton style={{ height: '100%', width: '50%' }} />
          </div>
          <div className={classes.mod_platform_info}>
            <Skeleton style={{ height: '100%', width: '60%' }} />
          </div>
        </div>
      </div>
    </div>
  );
}

function ConnectionCard({
  data, isLoading, clickHandler, cxname = '', css = {},
}) {
  if (isLoading) {
    return <ConnectionCardSkeleton />;
  }

  const {
    connected, title, name, icon, info, emptyText, buttonText,
  } = data || {};

  return (
    <div className={cx([classes.main_card], cxname)} style={css}>
      <div className={classes.mod_title}>{(title || '').toUpperCase()}</div>
      <div className={classes.mod_content}>
        {
          connected
            ? (
              <>
                <img src={icon} className={classes.mod_img} alt="" />
                <div className={classes.mod_info}>
                  <div className={classes.mod_platform_name}>{name}</div>
                  <div className={classes.mod_platform_info}>{info}</div>
                </div>
              </>
            )
            : (
              <>
                <div className={classes.disable_text}>{emptyText}</div>
                <div style={{ display: 'flex', flex: 1 }} />
                <div
                  className={classes.connect_button}
                  onClick={clickHandler}
                >
                  {buttonText}
                </div>
              </>
            )
        }
      </div>
    </div>
  );
}

ConnectionCard.proptype = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    connected: PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      info: PropTypes.string.isRequired,
    }),
    empty: PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      info: PropTypes.string.isRequired,
      clickHandler: PropTypes.func.isRequired,
      emptyText: PropTypes.string.isRequired,
      buttonText: PropTypes.string.isRequired,
    }),
  }),
};

export default ConnectionCard;
